$(function () {
  var param = window.location.search;
  const url = "https://media.ec-imsolution.com/shop/";
  if (param.length === 0) {
    $("#all").addClass("selected");
    $("#shoplist__content").attr("src", url);
  } else {
    switch (getParam("area", window.location.href)) {
      case "hokkaido":
        $("#hokkaido").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      case "kanto":
        $("#kanto").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      case "chubu":
        $("#chubu").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      case "kinki":
        $("#kinki").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      case "chugoku":
        $("#chugoku").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      case "shikoku":
        $("#shikoku").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      case "kyushu":
        $("#kyushu").addClass("selected");
        $("#shoplist__content").attr("src", url + param);
        break;
      default:
        $("#all").addClass("selected");
        $("#shoplist__content").attr("src", url);
    }
  }
});

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

window.addEventListener("message", (event) => {
  // 送信元のオリジンを確認
  if (event.origin !== "https://media.ec-imsolution.com") return; // 信頼できるオリジンのみ処理する

  if (event.data.data === void 0) {
    if (event.data.height !== void 0) {
      $("#shoplist__content").height(event.data.height);
    }
    if (event.data.insta !== void 0) {
      window.location.href = event.data.insta;
    }
  }
});
